import { render, staticRenderFns } from "./WorkClientContactTable.vue?vue&type=template&id=3477ef88&"
import script from "./WorkClientContactTable.vue?vue&type=script&lang=js&"
export * from "./WorkClientContactTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports